import { useMemo } from "react";
import { useRetriesForJob } from "~/components/build/Show/lib/BuildContext";
import { CommandJob } from "~/components/build/Show/lib/types";
import { Step } from "~/lib/pipeline";
import { Badge } from "~/components/build/Show/pages/steps/list/components/Badge";

const RetryLabel = ({ retryCount }: { retryCount: number }) => {
  if (retryCount === 0) {
    return null;
  }

  return (
    <Badge className="tabular-nums">
      {retryCount > 1 ? `${retryCount} retries` : `${retryCount} retry`}
    </Badge>
  );
};

export function StepRetries({ step }: { step: Step }) {
  const retryCount = useMemo(() => {
    return step.statistics?.retriesCount || 0;
  }, [step]);

  if (retryCount === 0) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}

export function JobRetries({ job }: { job: CommandJob }) {
  const jobs = useRetriesForJob(job);
  const retryCount = jobs.length - 1;

  if (!jobs.length) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}
